<template>
  <div class="app-container" style="padding: 0">
    <list
      row-key="UserId"
      ref="list"
      unit="合并工单"
      :page="page"
      show-query
      :query-params="params"
      :get-data-func="api.GetTaskDocList"
      @reset="$refs.picker.clear()"
      show-checkbox
      @check-change="onCheckChange2"
    >
      <!-- @row-select="rowSelect" -->
      <template slot="query">
        <el-form-item label="单据日期" prop="DocDate">
          <el-date-picker v-model="params.DocDate" type="date" placeholder="选择日期"> </el-date-picker>
        </el-form-item>
        <el-form-item label="工单号">
          <el-input style="width: 180px" clearable v-model="params.WorkDocNo" placeholder="请输入工单号" />
        </el-form-item>
        <el-form-item label="加工阶段">
          <invoice-select v-model="params.SourceTypeId" :clearable="false" />
        </el-form-item>
        <el-form-item label="存货名称" prop="ProductName">
          <el-input v-model="params.ProductName" placeholder="请输入存货名称" />
        </el-form-item>
        <el-form-item label="生产部门" label-width="100px">
          <v-select style="width: 180px" ref="typeSelect" v-model="params.DpId" clearable />
        </el-form-item>
        <el-form-item label="供应商">
          <el-select v-model="params.TradeUnitId" clearable>
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Sn" label="序号" width="50"></el-table-column>
        <el-table-column label="单据日期" prop="DocDate" align="center">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toDateString(row.DocDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="WorkDocNo" label="工单号" min-width="100" />
        <el-table-column prop="ProductName" label="存货名称" min-width="120" />
        <el-table-column prop="PropertyName" label="属性" min-width="80" align="center"></el-table-column>
        <el-table-column prop="ColorName" label="颜色" min-width="80" align="center"></el-table-column>
        <el-table-column prop="Quantity" label="数量" min-width="100" align="right">
          <template slot-scope="{ row }">
            {{ $commonJs.toThousands(row.Quantity) }}
          </template>
        </el-table-column>
        <el-table-column prop="ProcessStageDesc" label="加工阶段" min-width="120px" />
        <el-table-column prop="DpName" label="生产部门" min-width="120" />
        <el-table-column prop="TradeUnitName" label="加工商" min-width="120" />
      </template>
    </list>
    <div style="margin-top: -30px; float: right">
      <el-button type="primary" @click="getDetails">查询</el-button>
    </div>
    <el-table border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px" @selection-change="onCheckChange">
      <el-table-column type="selection" align="center" fixed :width="50" />
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="WarehouseName" label="领出仓" min-width="100" align="center"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.PropertyName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="center" />
      <el-table-column prop="Quantity" label="数量" min-width="100" align="right">
        <template slot-scope="{ row }">
          {{ $commonJs.toThousands(row.Quantity) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from '@/mixins/list'
import list from '@/components/common/list'
import moment from 'moment'
import vSelect from '@/components/business/stock/productionpicking/vSelect'
import invoiceSelect from '@/components/basedata/basedoc/billtype/select'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [listMixin],
  components: {
    list,
    vSelect,
    invoiceSelect
  },
  props: {
    tempParams: {
      typeof: Object,
      default: () => {}
    },
    type: {
      type: Boolean,
      default: true
    },
    docType: {
      type: Number,
      default: 1
    },
    tableType: {
      type: Number,
      default: 0
    },
    consumablesType: {
      type: Number,
      default: 0
    },
    DictionaryId: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    TradeUnitDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    tempParams(val) {
      console.log('val11111', val)
      this.params.status = val.status
      this.params.ProductionType = val.ProductionType
      this.params.InType = val.InType
      this.params.DpId = val.DpId
      this.params.OrderType = val.OrderType
      this.params.TradeUnitId = val.TradeUnitId
    }
  },
  data() {
    return {
      params: {
        DpId: '',
        TradeUnitId: '',
        ProductName: '',
        WarehouseId: null
      },
      data: {},
      commonApi: require('@/api/common/common').default,
      api: require('@/api/production/workDoc').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      selectList: [],
      arr: [],
      routesName: '',
      list: [],
      subList: [],
      tableData: [],
      extraList: [],
      TradeUnitId: null,
      TradeUnitDisabled: false,
      tradeUnitList: [],
      warehouseList: []
    }
  },
  created() {
    this.getParams()
    this.getTradeUnitList()
    this.getwarehouseList()
  },
  mounted() {
    this.onClear()
    this.getData()
  },
  methods: {
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date == undefined || date == '') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    getParams() {
      console.log('this.tempParams', this.tempParams)
      this.params.status = this.tempParams.status
      this.params.ProductionType = this.tempParams.ProductionType
      this.params.InType = this.tempParams.InType
      this.params.DpId = this.tempParams.DpId
      this.params.OrderType = this.tempParams.OrderType
      this.params.TradeUnitId = this.tempParams.TradeUnitId

      // if (this.tableType === 1) {
      //   this.params.Stage = this.tempParams.Stage
      // }
      // if(this.DictionaryId>0){
      //   this.params.ProcessStage=this.DictionaryId
      // }
    },

    getwarehouseList() {
      this.warehouseApi.list({}).then(res => {
        if (res.Code === 0) {
          this.warehouseList = res.Data
        }
      })
    },
    del() {},
    checkChange(list) {
      this.list = list
    },
    clear() {
      this.list = []
      this.subList = []
    },
    onCheckChange(list) {
      this.subList = list
    },
    getTradeUnitList() {
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 2, 3] }).then(res => {
        this.tradeUnitList = res.Data
      })
    },
    getDetails() {
      console.log('getDetails', JSON.parse(JSON.stringify(this.selectList)))

      var ids = this.selectList.map(x => x.WorkDocId)
      var ProductQtys = this.selectList.map(x => {
        return {
          ProductId: x.ProductId,
          Quantity: x.BaseQuantity
        }
      })
      const o = {
        ids,
        InType: this.params.InType,
        WarehouseId: this.params.WarehouseId,
        ProductQtys,
        Disabled: 0
      }
      console.log('🚀 ~ getDetails ~ o:', o)
      this.api.GetTaskDocInfos(o).then(res => {
        this.extraList = []
        if (res.Code === 0) {
          this.tableData = []
          res.Data.forEach(x => {
            x.Quantity = x.Quantity - (x.PrGetDocOccupyQuantity ?? 0)
          })
          let tList = res.Data.filter(item => item.Quantity > 0)
          this.tableData = [...this.tableData, ...tList]
          console.log('this.tableData', this.tableData)
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    onCheckChange2(data) {
      this.selectList = data
    },
    onClear() {
      this.selectList = []
      this.tableData = []
    }
  }
}
</script>
